const e = {
  telemedicine: "Virtual",
  in_person: "In-person",
  hybrid: "Virtual or in-person"
}, n = {
  telemedicine: "Virtual",
  in_person: "In-person"
}, o = {
  telemedicine: "Virtual",
  in_person: "In-person",
  hybrid: "Virtual or in-person"
}, i = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AvailableSessionFormat: e,
  SessionFormatBookingOptions: n,
  SessionFormatFilterOptions: o
}, Symbol.toStringTag, { value: "Module" }));
export {
  o as S,
  n as a,
  i as s
};
